import React from 'react'

export default function Footer() {
    return (
        <div>
            <footer className='w-full bg-slate-900 py-4 mt-12'>
                <h1 className='text-center text-white uppercase text-xs font-bold'>&copy;{new Date().toString().slice(11, 15)} All Rights Reserved by Abdullah Al Mahfuz</h1>
            </footer>
        </div>
    )
}
